import React from 'react'
import DefaultRoutinePlanMainTable from './DefaultRoutinePlanMainTable'
import { Box, Container, Divider } from '@mantine/core'
import BenchBreadcrumbs from '../UIComponent/Components/BenchBreadcrumbs'

const RoutineTemplate = () => {

    const breadcrumbLinks = [
       
        {
            label: "Routines",
            path: "/routineplan",
        },
        {
            label: "Routine Template",
         
           
        }
    ]
    return (
        <Container size="lg">
             <Box
            sx={(theme) => ({
              position: "sticky",
              top: 110, // Avoid overlapping the fixed navbar
              zIndex: 100,
              backgroundColor: "#FAFAFA",
              paddingTop: theme.spacing.sm,
              //paddingBottom: theme.spacing.xs,
              marginTop: `-${theme.spacing.sm}`,
            })}
          >
        <BenchBreadcrumbs links={breadcrumbLinks} />
        <Divider my="md" />
      </Box>
        <DefaultRoutinePlanMainTable />
        </Container>
    )
}

export default RoutineTemplate